import React, { useState } from "react";
import UpdateSettings from "./UpdateSettings";
import ContactInfo from "./ContactInfo";
import TermsandCondition from "./TermsandCondition";
import InvoiceData from "./InvoiceData";

const SettingsList = () => {
  const [activeTab, setActiveTab] = useState("invoicedata");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="p-3">
      <div className=" category-wrapper">
        <div
          className="d-flex align-items-center mb-3"
          style={{ columnGap: "10px" }}
        >
          <button
            onClick={() => handleTabClick("invoicedata")}
            className={`tab-button ${
              activeTab === "invoicedata" ? "active" : ""
            }`}
          >
            Invoice Info
          </button>
          <button
            onClick={() => handleTabClick("updatesettings")}
            className={`tab-button ${
              activeTab === "updatesettings" ? "active" : ""
            }`}
          >
            Referral Info
          </button>

          <button
            onClick={() => handleTabClick("contactinfo")}
            className={`tab-button ${
              activeTab === "contactinfo" ? "active" : ""
            }`}
          >
            Contact Info
          </button>
        </div>
        {activeTab === "updatesettings" && (
          <div className="category-wrapper">
            <UpdateSettings />
          </div>
        )}
        {activeTab === "invoicedata" && (
          <div className="card">
            <InvoiceData />
          </div>
        )}
        {activeTab === "contactinfo" && (
          <div className="category-wrapper">
            <ContactInfo />
          </div>
        )}
      </div>
    </div>
  );
};

export default SettingsList;
